'use strict';

exports.__esModule = true;

var _styledSystem = require('styled-system');

var textTransform = (0, _styledSystem.style)({
  prop: 'textTransform'
});
exports["default"] = (0, _styledSystem.compose)(_styledSystem.fontFamily, _styledSystem.fontSize, _styledSystem.fontWeight, _styledSystem.lineHeight, _styledSystem.letterSpacing, _styledSystem.fontStyle, _styledSystem.textAlign, textTransform);
module.exports = exports['default'];